import * as rollsData from './rollsData/rollsData'

import * as contributors from './contributors/contributors'

import * as aaMarkers from './aaMarkers/aaMarkers'
import * as aaTags from './aaTags/aaTags'

import * as aMarkers from './aMarkers/aMarkers'
import * as aTags from './aTags/aTags'

import * as aMovies from './aMovies/aMovies'

import * as aContact from './aContact/aContact'
import * as aUsers from './aUsers/aUsers'
import * as aUserLogs from './aUserLogs/aUserLogs'

import * as userMarkers from './userMarkers/userMarkers'
import * as newsAddress from './newsAddress/newsAddress'
import * as content from './content/content'

export {

  rollsData,
  contributors,
  aaMarkers,
  aaTags,
  aMarkers,
  aTags,
  aMovies,
  aContact,
  aUsers,
  aUserLogs,
  userMarkers,
  newsAddress,
  content,

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/model.js